import {ReactElement} from 'react';
import {Box, Typography} from '@mui/material';
import {Project} from 'interfaces/Project';

type Props = {
  project: Project;
};

export default function ProjectHeaderView({project}: Props): ReactElement {
  return (
    <Box sx={{mb: 4}}>
      <Box
        sx={{
          px: 2,
          py: 1,
          bgcolor: 'grey.500'
        }}
      >
        <Typography variant="h2" color="white">
          {project.name}
        </Typography>
      </Box>
    </Box>
  );
}
